import FormViewer from 'Components/FormViewer';
import SimpleList from 'Components/SimpleList';
import React from 'react';
import { useSelector } from 'react-redux';
import { unixToDate } from 'utils/date';
import displayMetadata from 'utils/displayMetadata';

const Component = props => {
    const measurement = useSelector(state => state.measurements.models[props.id]);
    const rootDevice = useSelector(state => state.devices.models[measurement.root_device_id]);
    const automationConditions = useSelector(state => state.automationConditions.models);

    const
        isNewWiseBox = rootDevice.new_wise_box,
        measurementAutomationCondition = Object.values(automationConditions).find(automationCondition => automationCondition.measurement_id === measurement.id);

    let attributes = [
        { label: 'ID', content: measurement.id },
        { label: 'Name', content: measurement.name },
        { label: 'Circuit Name', content: measurement.circuit_name || '-' },
        { label: 'Creation', content: `${measurement.creator_name} @ ${unixToDate(measurement.created_at)}` },
        { label: 'Update', content: `${measurement.updater_name} @ ${unixToDate(measurement.updated_at)}` }
    ];

    if (isNewWiseBox) {
        attributes.splice(3, 0, { label: 'WiseButton', content: measurement.wise_button_name || '-' });
        attributes.splice(4, 0, { label: 'Conditional', content: measurementAutomationCondition?.formula || '-' });
    }

    attributes = [...attributes, ...displayMetadata(measurement)];

    return (
        <FormViewer label="Measurement Details">
            <SimpleList content={attributes}/>
        </FormViewer>
    );
};

export default Component;
